/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Resend_Invite_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to resend the invite email. Please try again." |
*
* @param {Members_Resend_Invite_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_resend_invite_error = /** @type {((inputs?: Members_Resend_Invite_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Resend_Invite_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einladungs-E-Mail konnte nicht erneut gesendet werden. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Failed to resend the invite email. Please try again.")
});